var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericForm',{staticClass:"k-sub-form",class:{ vertical: _vm.schema.vertical },attrs:{"schema":_vm.genericFormSchema,"model":_vm.localData,"payload":_vm.payload},on:{"updated":_vm.onUpdate,"validated":_vm.onValidation}})}
var staticRenderFns = []

export { render, staticRenderFns }